import { axiosServices } from "./axiosServices";

export const purchaseOrderServices = { getPurchaseOrderListing, getPendingPOListing, getPORequestListing, getPOProductList, getPOProductsListing, poTakeAction, poAddMileStones, getPOTrackOrder, poPriceModification, getPORequestDetails, poModificationTakeAction, poModificationUpdateAssignee, getPORequestDetailsListing, updatePOPriceModificationReq, updatePOQTYModificationReq, getAccountLedgerListing };

function getPurchaseOrderListing(param) {
    return axiosServices.getAxios(`/v1/common/purchase-orders${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getPendingPOListing(param) {
    return axiosServices.getAxios(`/v1/common/purchase-orders/pending${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getPORequestListing(param) {
    return axiosServices.getAxios(`/v1/common/po-modification-requests${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getPOProductList(poId, param) {
    return axiosServices.getAxios(`/v1/common/purchase-orders/${poId}/products${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getPOProductsListing(poId, param) {
    return axiosServices.getAxios(`/v1/common/purchase-orders/${poId}/products${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function poTakeAction(bodyData) {
    return axiosServices.postAxios("/v1/common/purchase-orders/take-action", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function poAddMileStones(bodyData) {
    return axiosServices.postAxios("/v1/internal/purchase-orders/add-milestones", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getPOTrackOrder(param) {
    return axiosServices.getAxios(`/v1/common/purchase-orders/${param}/track-order`).then((res) => {
        // console.log(res);
        return res;
    });
}

function poPriceModification(bodyData) {
    return axiosServices.postAxios("/v1/common/po-modification-requests/price", bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getPORequestDetails(param) {
    return axiosServices.getAxios(`/v1/common/po-modification-requests/${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function poModificationTakeAction(id, bodyData) {
    return axiosServices.postAxios(`/v1/common/po-modification-requests/${id}/take-action`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function poModificationUpdateAssignee(id, bodyData) {
    return axiosServices.postAxios(`/v1/common/po-modification-requests/${id}/update-assignee`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getPORequestDetailsListing(id, param) {
    return axiosServices.getAxios(`/v1/common/po-modification-requests/${id}/line-items${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function updatePOQTYModificationReq(id, bodyData) {
    return axiosServices.putAxios(`/v1/common/po-modification-requests/${id}/quantity`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function updatePOPriceModificationReq(id, bodyData) {
    return axiosServices.putAxios(`/v1/common/po-modification-requests/${id}/price`, bodyData)
        .then((res) => {
            // console.log(res);
            return res;
        });
}

function getAccountLedgerListing(param) {
    return axiosServices.getAxios(`/v1/internal/account-ledgers${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}